import api from "./api";
import { Matter } from "../models/Matter";
import { Product } from "../models/Product";

const PATH = "/api/v1/checkout";

export const CheckoutService = {
  async checkoutProduct(
    product: Product,
    matter: Matter["_id"],
  ): Promise<string | null> {
    const response = await api.post(PATH, {
      priceId: product.id,
      matterId: matter,
    });
    return response.data.data.url;
  },

  async checkoutProfessionalProduct(product: Product): Promise<string | null> {
    const response = await api.post(PATH, {
      priceId: product.id,
    });
    return response.data.data.url;
  },
};
